import * as React from 'react';
import styled from 'styled-components';
import { useState } from 'react';
import { ClusterButton } from './ClusterButton';
import { CLUSTER_DATA } from './ClusterButton.types';
import { Spacing } from '../../common/spacings';
import { NeutralColors } from '../../common/colors';
import { screen } from '../../common/breakpoints';

interface ClusteredButtonContainerProps {
  tabs: CLUSTER_DATA[];
  activeTab: string;
  onTabChange: (label: string) => void;
}

export const CTAClusterContainer = styled.div`
  display: flex;
  gap: ${Spacing.XL};
  pointer-events: all;
  background-color: ${NeutralColors.Black};
  padding: 15px 30px;
  border-radius: 50px;
  width: fit-content;
  justify-content: center;

  @media screen and (${screen.m}) {
    display: flex;
    gap: ${Spacing.XL};
    pointer-events: all;
    width: fit-content;
    background-color: ${NeutralColors.Black};
    border-radius: 50px;
    padding: 15px 30px;
  }
`;

export const DividerLine = styled.div`
  width: 1px;
  height: 24px;
  margin: 0 4px;
  background-color: ${NeutralColors.DarkGrey};
  justify-self: center;
`;

export const ClusteredButtonContainer = ({
  tabs,
  activeTab,
  onTabChange,
}: ClusteredButtonContainerProps): JSX.Element => {
  const [activeIndex, setActiveIndex] = useState(activeTab);

  const handleTabClick = (label: string) => {
    setActiveIndex(label);
    onTabChange(label);
  };

  return (
    <CTAClusterContainer data-testid="cluster-button-container">
      {tabs.map((tab: CLUSTER_DATA, index) => (
        <React.Fragment key={tab.name}>
          <ClusterButton
            active={activeIndex === tab.name}
            handleClick={() => handleTabClick(tab.name)}
            icon={tab.icon}
          />
          {index !== tabs.length - 1 && <DividerLine />}
        </React.Fragment>
      ))}
    </CTAClusterContainer>
  );
};
